import { Stack, Typography } from '@mui/material';
import { useTenant } from '@/tenant/useTenant';
import { BrandMark } from './BrandMark';

interface BrandLogoProps {
  size?: 'small' | 'medium' | 'large';
  /** Hide the name next to the mark (e.g. when the logo already contains it). */
  markOnly?: boolean;
}

const sizes = {
  small: { mark: 32, font: '1.125rem' },
  medium: { mark: 40, font: '1.375rem' },
  large: { mark: 48, font: '1.625rem' },
} as const;

/** Mark + name of the current space (tenant) or of the platform. */
export function BrandLogo({ size = 'medium', markOnly = false }: BrandLogoProps) {
  const { displayName } = useTenant();
  const s = sizes[size];
  return (
    <Stack direction="row" spacing={1.5} sx={{ alignItems: 'center', minWidth: 0 }}>
      <BrandMark size={s.mark} />
      {!markOnly && (
        <Typography
          component="span"
          noWrap
          sx={{ fontSize: s.font, fontWeight: 600, letterSpacing: '-0.01em' }}
        >
          {displayName}
        </Typography>
      )}
    </Stack>
  );
}
